export const FINISHED_ROOM_TYPE = 'finished';
export const UNFINISHED_ROOM_TYPE = 'unfinished';
